<!-- <div class="pt-100">
    <div class="title-breadcumbs">
        <div class="container">
            <div class="entry-header">
                <h2 class="entry-title">{{'label-title.about-us' | translate}}</h2>
            </div>
            <div class="breadcrumb-container">
                <div class="breadcrumbs">
                    <a href="javascript:;">{{"label-title.home" | translate}}</a><span
                        class="separator">&gt;</span><span>{{'label-title.about-us' | translate}}</span>
                    </div>
            </div>
        </div>
    </div>
</div>

<div class="about-content">
    <div class="container">
        <div class="about-banner">
            <img src="../../../../assets/img/about-us-banner1.jpg" class="w-100" alt="">
            <h2 class="mx-5 text-center">{{'label-title.about-banner-main-header-content' | translate}}</h2>
            <p class="mx-4 text-center">Adipiscing lacus ut elementum, nec duis, tempor litora turpis dapibus. Imperdiet
                cursus odio
                tortor in
                elementum. Egestas nunc eleifend feugiat lectus laoreet, vel nunc taciti integer cras. Hac pede dis,
                praesent nibh ac dui mauris sit. Pellentesque mi, facilisi mauris, elit sociis leo sodales accumsan.
                Iaculis ac fringilla torquent lorem consectetuer, sociosqu phasellus risus urna aliquam, ornare.</p>
        </div>
    </div>
</div>


<div class="feature-list">
    <div class="container">
        <div class="row">
            <div class="col-4">
                <div class="text-center p-3">
                    <img src="../../../../assets/img/about-us-policy1.png" class="mb-4" alt="">
                    <h5>{{'label-title.creative-design' | translate}}</h5>
                    <p>Erat metus sodales eget dolor consectetuer, porta ut purus at et alias, nulla ornare velit
                        amet enim</p>
                </div>
            </div>
            <div class="col-4">
                <div class="text-center p-3">
                    <img src="../../../../assets/img/about-us-policy2.png" class="mb-4" alt="">
                    <h5>{{'label-title.money-back-guarantee' | translate}}</h5>
                    <p>Erat metus sodales eget dolor consectetuer, porta ut purus at et alias, nulla ornare velit
                        amet enim</p>
                </div>
            </div>
            <div class="col-4">
                <div class="text-center p-3">
                    <img src="../../../../assets/img/about-us-policy3.png" class="mb-4" alt="">
                    <h5>{{'label-title.online-support' | translate}}</h5>
                    <p>Erat metus sodales eget dolor consectetuer, porta ut purus at et alias, nulla ornare velit
                        amet enim</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="our-vision pb-4">
    <div class="container">
        <div class="row">
            <div class="col-4 mb-3">
                <div class="">
                    <div class="card-image mb-4">
                        <img src="../../../../assets/img/about-us-banner2-1.jpg" alt="">
                    </div>
                    <h5>What do we do?</h5>
                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
                        totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto</p>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="">
                    <div class="card-image mb-4">
                        <img src="../../../../assets/img/about-us-banner2-2.jpg" alt="">
                    </div>
                    <h5>Our Mission</h5>
                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
                        totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto</p>
                </div>
            </div>
            <div class="col-4 mb-3">
                <div class="">
                    <div class="card-image mb-4">
                        <img src="../../../../assets/img/about-us-banner2-3.jpg" alt="">
                    </div>
                    <h5>History Of Us</h5>
                    <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
                        totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="choose-us review_part">
    <div class="container">
        <h4>Why You Choose Us ?</h4>
        <p>Mirum est notare quam littera gothica, quam nunc putamus parum claram anteposuerit litterarum.</p>

        <div ngbAccordion class="mt-4" [closeOthers]="true">
            <div ngbAccordionItem [collapsed]="false">
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>Fast Free Deliver</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            Nam liber tempor cum soluta nobis eleifend option.
                            Congue nihil imperdiet doming id quod mazim placerat facer possim assum. Typi non habent
                            claritatem insitam est usus legentis in iis qui facit eorum claritatem. Investigationes
                            demonstraverunt lectores legere me.

                            Claritas est etiam processus dynamicus, qui sequitur mutationem consuetudium lectorum.
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>More Than 10 Years In The Business</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            Nam liber tempor cum soluta nobis eleifend option.
                            Congue nihil imperdiet doming id quod mazim placerat facer possim assum. Typi non habent
                            claritatem insitam est usus legentis in iis qui facit eorum claritatem. Investigationes
                            demonstraverunt lectores legere me.

                            Claritas est etiam processus dynamicus, qui sequitur mutationem consuetudium lectorum.
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>100% Organic Foods</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            Nam liber tempor cum soluta nobis eleifend option.
                            Congue nihil imperdiet doming id quod mazim placerat facer possim assum. Typi non habent
                            claritatem insitam est usus legentis in iis qui facit eorum claritatem. Investigationes
                            demonstraverunt lectores legere me.

                            Claritas est etiam processus dynamicus, qui sequitur mutationem consuetudium lectorum.
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>Best Shopping Strategies</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            Nam liber tempor cum soluta nobis eleifend option.
                            Congue nihil imperdiet doming id quod mazim placerat facer possim assum. Typi non habent
                            claritatem insitam est usus legentis in iis qui facit eorum claritatem. Investigationes
                            demonstraverunt lectores legere me.

                            Claritas est etiam processus dynamicus, qui sequitur mutationem consuetudium lectorum.
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="pt-100">
    <div class="title-breadcumbs">
        <div class="container">
            <div class="entry-header">
                <h2 class="entry-title">{{'label-title.about-us' | translate}}</h2>
            </div>
            <div class="breadcrumb-container">
                <div class="breadcrumbs">
                    <a href="javascript:;">{{"label-title.home" | translate}}</a><span
                        class="separator">&gt;</span><span>{{'label-title.about-us' | translate}}</span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="about-content">
    <div class="container">
        <div class="about-banner">
            <img src="../../../../assets/img/home-page/IMG_0404.JPG" class="w-100" alt="">
            <h2 class="mx-5 text-center">{{'heading-title.about-banner-main-header-content' | translate}}</h2>
            <p class="mx-4 text-center">{{'paragraph-title.about-banner-content-para' | translate}}</p>
        </div>
    </div>
</div>

<div class="feature-list">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-4">
                <div class="text-center p-3">
                    <img src="../../../../assets/img/imitation-jewelry-design.webp" class="mb-4" alt="">
                    <h5>{{'label-title.creative-design' | translate}}</h5>
                    <p>{{'paragraph-title.creative-design-para' | translate}} </p>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="text-center p-3">
                    <img src="../../../../assets/img/imitation-jewelry-quality.webp" class="mb-4" alt="">
                    <h5>{{'label-title.jewelry-quality' | translate}}</h5>
                    <p>{{'paragraph-title.jewelry-quality-para' | translate}}</p>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="text-center p-3">
                    <img src="../../../../assets/img/imitation-jewelry-support.webp" class="mb-4" alt="">
                    <h5>{{'label-title.online-support' | translate}}</h5>
                    <p>{{'paragraph-title.online-support-para' | translate}}</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="our-vision pb-4">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-4 ">
                <div class="p-3">
                    <div class="card-image mb-4">
                        <img src="../../../../assets/img/home-page/IMG_0399.JPG" alt="Elegant Design">
                    </div>
                    <h5>{{'label-title.what-do-we-do' | translate}}</h5>
                    <p>{{ 'paragraph-title.what-do-we-do-para' | translate}}</p>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="p-3">
                    <div class="card-image mb-4">
                        <img src="../../../../assets/img/home-page/IMG_0400.JPG" alt="Mission of Excellence">
                    </div>
                    <h5>{{'label-title.our-mission' | translate}}</h5>
                    <p>{{'paragraph-title.our-mission-para' | translate}} </p>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="p-3">
                    <div class="card-image mb-4">
                        <img src="../../../../assets/img/home-page/IMG_0401.JPG" alt="Legacy of Craftsmanship">
                    </div>
                    <h5>{{'label-title.history-of-us' | translate}}</h5>
                    <p>{{'paragraph-title.history-of-us-para' | translate}}</p>
                </div>
            </div>
        </div>        
    </div>
</div>

<div class="choose-us review_part">
    <div class="container">
        <h4>{{'label-title.why-choose-us' | translate}}</h4>
        <p>{{'paragraph-title.why-choose-us-para' | translate}}</p>

        <div ngbAccordion class="mt-4" [closeOthers]="true">
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>{{'label-title.experienced-craftsmanship' | translate}}</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            {{'paragraph-title.experienced-craftsmanship-para' | translate}}
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>{{'label-title.organic-designs' | translate}}</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                              {{'paragraph-title.organic-designs-para' | translate}}  
                        </ng-template>
                    </div>
                </div>
            </div>
            <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                    <button ngbAccordionButton>{{'label-title.best-shopping-strategies' | translate}}</button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            {{'paragraph-title.best-shopping-strategies-para' | translate}}
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
